export const SEZNAM_API_KEY = 'S0Ogh7IuAN0NeguyW7WrQa4IDpduXPmNc810YZoxlu4';

export const DEFAULT_HEIGHT = 600;
export const DEFAULT_WIDTH = 600;

export const MAX_WIDTH = 1024;
